export const formatPolicyNumber = (code) => {
    if (!code) return 'N/A';
    return /^POL[^-]/.test(code) ? `POL-${code.slice(3)}` : code;
};

export const formatPolicyDate = (t, date) => {
    if (!date) return 'N/A';

    return t('common.date', {
        date,
        formatParams: {
            date: { year: 'numeric', month: 'short', day: 'numeric' }
        }
    });
};
